import axios from 'axios';

const BASE_URL = `${process.env.REACT_APP_API_URL}/api/auth`;

export const loginApi = async (credentials) => {
  const response = await axios.post(`${BASE_URL}/login`, credentials);
  return response;
};

export const resetApi = async (credentials) => {
  const response = await axios.post(`${BASE_URL}/reset`, credentials);
  return response;
};

export const changeApi = async (credentials) => {
  const response = await axios.post(`${BASE_URL}/change`, credentials);
  return response;
};

export const forgotApi = async (email) => {
  const response = await axios.post(`${BASE_URL}/forgot`, { email });
  return response;
};
